import { FormValidation } from '../../js/libraries/validation';

export class DynamicForm
{
    constructor() {
        this.formArea = document.querySelector('.dynamic-form');

        if(this.formArea !== null) {
            this.form = this.formArea.querySelector('form');

            if(this.form !== null) {
                this.formValidator = new FormValidation(this.form);

                this.form.addEventListener('submit', (e) => {
                    e.preventDefault();

                    if (this.formValidator.validateFields()) {
                        this.submitForm();
                    }
                });

                this.initialiseRadio();
                this.initialiseCheckbox();
            }
        }
    }

    submitForm () {

        let data = this.getFormData();

        let sendData = fetch(window.location.pathname, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "same-origin"
        }).then(function(response) {
            return response.json();
        }, function(error) {
            console.log(error.message) //=> String
        }).then(function(response){
            if (response.redirect) {
                window.location = response.redirect;
            }
        });

        this.formArea.querySelector('.success-message').classList.remove('hide');
        this.form.remove();

    }

    getFormData() {
        let data = {};
        this.formValidator.inputs.forEach((field)=>{
            data[field.getAttribute('name')] = field.value;
        });

        return data;
    }

    initialiseCheckbox() {
        let phoneField = this.form.querySelector('input[name=phone]');
        if (this.checkbox = this.form.querySelector('input[name="callback"]')) {
            this.checkbox.addEventListener('change', e => {
                if (e.target.checked) {
                    this.formValidator.makeRequiredField(phoneField, 'phone');
                } else {
                    this.formValidator.makeOptionalField(phoneField);
                    phoneField.removeAttribute('data-required');
                }
            });
        }
    }

    initialiseRadio() {
        this.radioOptions = this.form.querySelectorAll('input[name="reach"]');
        this.radioOptions.forEach((radio)=>{ this.initRadioOption(radio) });
    }

    initRadioOption(radio) {
        let phoneField = this.form.querySelector('input[name=phone]'),
            emailField = this.form.querySelector('input[name=email]');

        radio.addEventListener('change', e=>{
            let value = radio.value;

            if(value === 'phone') {
                this.formValidator.makeRequiredField(phoneField, 'phone');
                this.formValidator.makeOptionalField(emailField);
            } else {
                phoneField.removeAttribute('data-required');
                this.formValidator.makeRequiredField(emailField, 'email');
                this.formValidator.makeOptionalField(phoneField);
            }
        });
    }


}


// WEBPACK FOOTER //
// ./assets/sass/shared/form.js